import {
  type OfferV11,
  type PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { priceAccessorGetDisplayPrice } from './priceAccessorGetDisplayPrice'
import { priceAccessorGetThirtyDaysLowestPrice } from './priceAccessorGetThirtyDaysLowestPrice'

export enum PRODUCT_THIRTY_DAYS_PRICE_TREND {
  PRICE_DOWN = 'PRICE_DOWN',
  PRICE_NO_CHANGE = 'PRICE_NO_CHANGE',
  PRICE_UP = 'PRICE_UP',
}
export const priceAccessorGetThirtyDaysPriceTrend = (
  offer: OfferV11 | undefined,
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum,
): PRODUCT_THIRTY_DAYS_PRICE_TREND => {
  if (!offer) {
    return PRODUCT_THIRTY_DAYS_PRICE_TREND.PRICE_NO_CHANGE
  }

  const { price: currentPrice = 0 } =
    priceAccessorGetDisplayPrice(offer, currentPrescriptionType) ?? {}
  const { amount: thirtyDaysLowestPrice = 0 } =
    priceAccessorGetThirtyDaysLowestPrice(offer) ?? {}

  if (thirtyDaysLowestPrice > currentPrice) {
    return PRODUCT_THIRTY_DAYS_PRICE_TREND.PRICE_DOWN
  } else if (thirtyDaysLowestPrice < currentPrice) {
    return PRODUCT_THIRTY_DAYS_PRICE_TREND.PRICE_UP
  }

  return PRODUCT_THIRTY_DAYS_PRICE_TREND.PRICE_NO_CHANGE
}
